module.exports = __webpack_public_path__ + "img/addressBook.e29cb3ef.png";